import { OrderFieldsCreateResp } from '@api/responseModels/orderFields/orderFieldsCreateResponse';
import { OrderFieldsGetAllResp } from '@api/responseModels/orderFields/orderFieldsGetAllResponse';
import { OrderFieldsResp } from '@api/responseModels/orderFields/orderFieldsResponse';
import { RequestResult } from '@api/responseModels/requestResult';

import { CRMAPIBase } from '../../crmApiBase';

class OrderFieldsGroup extends CRMAPIBase {
    //TODO: вероятно устарел
    async updateOrderFieldName(
        fieldId,
        crm_id: number,
        name: string
    ): Promise<RequestResult<OrderFieldsResp>> {
        const result = await this.put<OrderFieldsResp>(`order-fields/${fieldId}`, {
            crm_id,
            name,
            id: fieldId,
        });
        return result;
    }

    async updateOrderField(fieldId: number, fields): Promise<RequestResult<OrderFieldsResp>> {
        const result = await this.put<OrderFieldsResp>(`order-fields/${fieldId}`, {
            ...fields,
        });
        return result;
    }

    async updateOrderFieldOptions(
        fieldId: number,
        entityId,
        options
    ): Promise<RequestResult<OrderFieldsResp>> {
        const result = await this.put<OrderFieldsResp>(`order-fields/${fieldId}`, {
            type: 'object_category',
            entity_id: entityId,
            values: options,
        });
        return result;
    }

    async createOrderFieldOptions(
        fieldId: number,
        entityId: number,
        text: string
    ): Promise<RequestResult<OrderFieldsResp>> {
        const result = await this.put<OrderFieldsResp>(`order-fields/${fieldId}`, {
            mode: 'with_all_values',
            type: 'object_category',
            entity_id: entityId,
            values: [
                {
                    value: text,
                    status: false,
                },
            ],
        });
        return result;
    }

    async sortOrderFields(
        positions: {
            id: number;
            position: number;
        }[]
    ): Promise<RequestResult<OrderFieldsResp>> {
        const result = await this.post<OrderFieldsResp>(`order-fields/sort`, {
            positions,
        });
        return result;
    }

    async getOrderFields(params: {
        crm_id: number;
        worksheetId: number;
        query: string;
    }): Promise<RequestResult<OrderFieldsResp>> {
        const { worksheetId, ...data } = params;
        const result = await this.get<OrderFieldsResp>(`order-fields`, {
            'filters[worksheets][0]': worksheetId,
            ...data,
        });
        return result;
    }

    async getAllOrderFields(params?: {
        crm_id?: number;
        page?: number;
        per_page?: number;
    }): Promise<RequestResult<OrderFieldsGetAllResp>> {
        const result = await this.get<OrderFieldsGetAllResp>(`fields/get-all-fields`, params);
        return result;
    }

    async createOrderFieldOld(params: {
        worksheet_id: number;
        crm_id: number;
        name: string;
        is_photo: boolean;
        is_used: boolean;
        is_required?: boolean;
        is_saved?: boolean;
    }): Promise<RequestResult<OrderFieldsCreateResp>> {
        const result = await this.post<OrderFieldsCreateResp>(`order-fields`, params);
        return result;
    }

    async createOrderField(
        name: string,
        entity_id: number
    ): Promise<RequestResult<OrderFieldsCreateResp>> {
        const result = await this.post<OrderFieldsCreateResp>(`order-fields`, {
            name,
            entity_id: entity_id,
            is_photo: false,
            type: 'object_category',
            status: 'main',
            // values: [],
        });
        return result;
    }

    async getOrderField(
        crm_id: number,
        field_id: number,
        entity_id: number,
        mode?: string
    ): Promise<RequestResult<OrderFieldsCreateResp>> {
        const result = await this.get<OrderFieldsCreateResp>(`order-fields/${field_id}`, {
            crm_id,
            type: 'object_category',
            entity_id: entity_id,
            ...(mode ? { mode } : {}),
        });
        return result;
    }

    async deleteOrderField(
        crm_id: number,
        field_id: number
    ): Promise<RequestResult<OrderFieldsCreateResp>> {
        const result = await this.delete<OrderFieldsCreateResp>(`order-fields/${field_id}`, {
            crm_id,
        });
        return result;
    }
}

export { OrderFieldsGroup };
